import script from "./withholdingReceived.vue?vue&type=script&setup=true&lang=js"
export * from "./withholdingReceived.vue?vue&type=script&setup=true&lang=js"

import "./withholdingReceived.vue?vue&type=style&index=0&id=6138c0cb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6138c0cb"]])

export default __exports__